function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, DatePicker, Space, InputNumber, Radio, Checkbox, Divider, Alert } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import Common from "../includes/Common";
import moment from 'moment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var CheckboxGroup = Checkbox.Group;
var TextArea = Input.TextArea;

var MedForm = function MedForm(_ref) {
  var candidat = _ref.candidat,
      handler = _ref.handler;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFormProcessing = _useState4[0],
      setIsFormProcessing = _useState4[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append('weight', values.weight);
    formData.append('tallness', values.tallness);
    formData.append('ta', values.ta);
    formData.append('fc', values.fc);
    formData.append('fr', values.fr);
    formData.append('temperature', values.temperature);
    formData.append('hasDisability', values.hasDisability);
    formData.append('hasDisabilityComment', values.hasDisabilityComment);
    formData.append('hasInjury', values.hasInjury);
    formData.append('hasInjuryComment', values.hasInjuryComment);
    formData.append('eyeWards', values.eyeWards);
    formData.append('eyeWardsComment', values.eyeWardsComment);
    formData.append('orl', values.orl);
    formData.append('orlComment', values.orlComment);
    formData.append('teethMouth', values.teethMouth);
    formData.append('teethMouthComment', values.teethMouthComment);
    formData.append('lungChest', values.lungChest);
    formData.append('lungChestComment', values.lungChestComment);
    formData.append('cardiovascular', values.cardiovascular);
    formData.append('cardiovascularComment', values.cardiovascularComment);
    formData.append('abs', values.abs);
    formData.append('absComment', values.absComment);
    formData.append('musculoskeletal', values.musculoskeletal);
    formData.append('musculoskeletalComment', values.musculoskeletalComment);
    formData.append('skinVarice', values.skinVarice);
    formData.append('skinVariceComment', values.skinVariceComment);
    formData.append('lymphNodes', values.lymphNodes);
    formData.append('lymphNodesComment', values.lymphNodesComment);
    formData.append('hasDizziness', values.hasDizziness);
    formData.append('hasEpilepsy', values.hasEpilepsy);
    formData.append('hasFainting', values.hasFainting);
    formData.append('hasBloodyNose', values.hasBloodyNose);
    formData.append('hasEardischarge', values.hasEardischarge);
    formData.append('hasEarProblem', values.hasEarProblem);
    formData.append('hasSinusTrouble', values.hasSinusTrouble);
    formData.append('hasSleepApnea', values.hasSleepApnea);
    formData.append('hasHeadach', values.hasHeadach);
    formData.append('hasEyeTrouble', values.hasEyeTrouble);
    formData.append('heartTrouble', values.heartTrouble);
    formData.append('hasAcuteArticularRhumatism', values.hasAcuteArticularRhumatism);
    formData.append('hasChestHurt', values.hasChestHurt);
    formData.append('hasHighBloodPressure', values.hasHighBloodPressure);
    formData.append('hasPalpitations', values.hasPalpitations);
    formData.append('hasArthritis', values.hasArthritis);
    formData.append('hasChestHandsNumbness', values.hasChestHandsNumbness);
    formData.append('hasFrequentColdThroatHurt', values.hasFrequentColdThroatHurt);
    formData.append('hasSciaticaBackPain', values.hasSciaticaBackPain);
    formData.append('mentalTrouble', values.mentalTrouble);
    formData.append('hasAvc', values.hasAvc);
    formData.append('hasPneumoniaPleurisy', values.hasPneumoniaPleurisy);
    formData.append('hasHayAsthmaCold', values.hasHayAsthmaCold);
    formData.append('hasPhysicalInactivity', values.hasPhysicalInactivity);
    formData.append('hasMuchSputum', values.hasMuchSputum);
    formData.append('hasBloodySputum', values.hasBloodySputum);
    formData.append('hasWeightLoss', values.hasWeightLoss);
    formData.append('hasChronicFieverFatigue', values.hasChronicFieverFatigue);
    formData.append('hasNightySweat', values.hasNightySweat);
    formData.append('hasShortnessOfBreath', values.hasShortnessOfBreath);
    formData.append('hasLossAppetite', values.hasLossAppetite);
    formData.append('hasBloodyVomit', values.hasBloodyVomit);
    formData.append('hasStomachDigestionIssue', values.hasStomachDigestionIssue);
    formData.append('hasStomachUlcer', values.hasStomachUlcer);
    formData.append('hasBloodyStool', values.hasBloodyStool);
    formData.append('hasJointPain', values.hasJointPain);
    formData.append('hasKidneyBladderDesease', values.hasKidneyBladderDesease);
    formData.append('hasEyeInjury', values.hasEyeInjury);
    formData.append('hasChronicDiarrheaConstipation', values.hasChronicDiarrheaConstipation);
    formData.append('hasBackInjury', values.hasBackInjury);
    formData.append('hasAllergies', values.hasAllergies);
    formData.append('hasFractures', values.hasFractures);
    formData.append('hasBlockedKnee', values.hasBlockedKnee);
    formData.append('hasFlatFoot', values.hasFlatFoot);
    formData.append('hasMuscularPainSprain', values.hasMuscularPainSprain);
    formData.append('hasHernia', values.hasHernia);
    formData.append('hasNervousDisorder', values.hasNervousDisorder);
    formData.append('hasDermatitis', values.hasDermatitis);
    formData.append('hasJaundice', values.hasJaundice);
    formData.append('hasDiabete', values.hasDiabete);
    formData.append('hasWearingLenses', values.hasWearingLenses);
    formData.append('hasAdviceSurgery', values.hasAdviceSurgery);
    formData.append('hasVaricoseVein', values.hasVaricoseVein);
    formData.append('hasFootSwelling', values.hasFootSwelling);
    formData.append('hasBloodyUrine', values.hasBloodyUrine);
    formData.append('hasMenstrualDisorders', values.hasMenstrualDisorders);
    formData.append('hasCurrentMedication', values.hasCurrentMedication);
    formData.append('dailyGlassOfAlcohol', values.dailyGlassOfAlcohol);
    formData.append('otherMedicalTroubles', values.otherMedicalTroubles);
    formData.append("dailyAmountOfCigaret", values.dailyAmountOfCigaret);
    formData.append('isSportPractician', values.isSportPractician);
    formData.append('isSportPracticianComment', values.isSportPracticianComment);
    formData.append('yesComment', values.yesComment);
    formData.append('medicationList', values.medicationList);
    formData.append('user_id', Common.currentUser.id);
    formData.append('customer_id', candidat.id);
    axios.post(Common.baseApiUrl + 'setmedicalcheck', formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue');
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };

  useEffect(function () {
    if (candidat.medecine_questions_id != null) {
      form.setFieldsValue({
        weight: candidat.medecine_questions.weight,
        tallness: candidat.medecine_questions.tallness,
        ta: candidat.medecine_questions.ta,
        fc: candidat.medecine_questions.fc,
        fr: candidat.medecine_questions.fr,
        temperature: candidat.medecine_questions.temperature,
        hasDisability: candidat.medecine_questions.hasDisability,
        hasDisabilityComment: candidat.medecine_questions.hasDisabilityComment,
        hasInjury: candidat.medecine_questions.hasInjury,
        hasInjuryComment: candidat.medecine_questions.hasInjuryComment,
        eyeWards: candidat.medecine_questions.eyeWards,
        eyeWardsComment: candidat.eyeWardsComment,
        orl: candidat.medecine_questions.orl,
        orlComment: candidat.medecine_questions.orlComment,
        teethMouth: candidat.medecine_questions.teethMouth,
        teethMouthComment: candidat.medecine_questions.teethMouthComment,
        lungChest: candidat.medecine_questions.lungChest,
        lungChestComment: candidat.medecine_questions.lungChestComment,
        cardiovascular: candidat.medecine_questions.cardiovascular,
        cardiovascularComment: candidat.medecine_questions.cardiovascularComment,
        abs: candidat.medecine_questions.abs,
        absComment: candidat.medecine_questions.absComment,
        musculoskeletal: candidat.medecine_questions.musculoskeletal,
        musculoskeletalComment: candidat.medecine_questions.musculoskeletalComment,
        skinVarice: candidat.medecine_questions.skinVarice,
        skinVariceComment: candidat.medecine_questions.skinVariceComment,
        lymphNodes: candidat.medecine_questions.lymphNodes,
        lymphNodesComment: candidat.medecine_questions.lymphNodesComment,
        hasDizziness: candidat.medecine_questions.hasDizziness,
        hasEpilepsy: candidat.medecine_questions.hasEpilepsy,
        hasFainting: candidat.medecine_questions.hasFainting,
        hasBloodyNose: candidat.medecine_questions.hasBloodyNose,
        hasEardischarge: candidat.medecine_questions.hasEardischarge,
        hasEarProblem: candidat.medecine_questions.hasEarProblem,
        hasSinusTrouble: candidat.medecine_questions.hasSinusTrouble,
        hasSleepApnea: candidat.medecine_questions.hasSleepApnea,
        hasHeadach: candidat.medecine_questions.hasHeadach,
        hasEyeTrouble: candidat.medecine_questions.hasEyeTrouble,
        heartTrouble: candidat.medecine_questions.heartTrouble,
        hasAcuteArticularRhumatism: candidat.medecine_questions.hasAcuteArticularRhumatism,
        hasChestHurt: candidat.medecine_questions.hasChestHurt,
        hasHighBloodPressure: candidat.medecine_questions.hasHighBloodPressure,
        hasPalpitations: candidat.medecine_questions.hasPalpitations,
        hasArthritis: candidat.medecine_questions.hasArthritis,
        hasChestHandsNumbness: candidat.medecine_questions.hasChestHandsNumbness,
        hasFrequentColdThroatHurt: candidat.medecine_questions.hasFrequentColdThroatHurt,
        hasSciaticaBackPain: candidat.medecine_questions.hasSciaticaBackPain,
        mentalTrouble: candidat.medecine_questions.mentalTrouble,
        hasAvc: candidat.medecine_questions.hasAvc,
        hasPneumoniaPleurisy: candidat.medecine_questions.hasPneumoniaPleurisy,
        hasHayAsthmaCold: candidat.medecine_questions.hasHayAsthmaCold,
        hasPhysicalInactivity: candidat.medecine_questions.hasPhysicalInactivity,
        hasMuchSputum: candidat.medecine_questions.hasMuchSputum,
        hasBloodySputum: candidat.medecine_questions.hasBloodySputum,
        hasWeightLoss: candidat.medecine_questions.hasWeightLoss,
        hasChronicFieverFatigue: candidat.medecine_questions.hasChronicFieverFatigue,
        hasNightySweat: candidat.medecine_questions.hasNightySweat,
        hasShortnessOfBreath: candidat.medecine_questions.hasShortnessOfBreath,
        hasLossAppetite: candidat.medecine_questions.hasLossAppetite,
        hasBloodyVomit: candidat.medecine_questions.hasBloodyVomit,
        hasStomachDigestionIssue: candidat.medecine_questions.hasStomachDigestionIssue,
        hasStomachUlcer: candidat.medecine_questions.hasStomachUlcer,
        hasBloodyStool: candidat.medecine_questions.hasBloodyStool,
        hasJointPain: candidat.medecine_questions.hasJointPain,
        hasKidneyBladderDesease: candidat.medecine_questions.hasKidneyBladderDesease,
        hasEyeInjury: candidat.medecine_questions.hasEyeInjury,
        hasChronicDiarrheaConstipation: candidat.medecine_questions.hasChronicDiarrheaConstipation,
        hasBackInjury: candidat.medecine_questions.hasBackInjury,
        hasAllergies: candidat.medecine_questions.hasAllergies,
        hasFractures: candidat.medecine_questions.hasFractures,
        hasBlockedKnee: candidat.medecine_questions.hasBlockedKnee,
        hasFlatFoot: candidat.medecine_questions.hasFlatFoot,
        hasMuscularPainSprain: candidat.medecine_questions.hasMuscularPainSprain,
        hasHernia: candidat.medecine_questions.hasHernia,
        hasNervousDisorder: candidat.medecine_questions.hasNervousDisorder,
        hasDermatitis: candidat.medecine_questions.hasDermatitis,
        hasJaundice: candidat.medecine_questions.hasJaundice,
        hasDiabete: candidat.medecine_questions.hasDiabete,
        hasWearingLenses: candidat.medecine_questions.hasWearingLenses,
        hasAdviceSurgery: candidat.medecine_questions.hasAdviceSurgery,
        hasVaricoseVein: candidat.medecine_questions.hasVaricoseVein,
        hasFootSwelling: candidat.medecine_questions.hasFootSwelling,
        hasBloodyUrine: candidat.medecine_questions.hasBloodyUrine,
        hasMenstrualDisorders: candidat.medecine_questions.hasMenstrualDisorders,
        hasCurrentMedication: candidat.medecine_questions.hasCurrentMedication,
        dailyGlassOfAlcohol: candidat.medecine_questions.dailyGlassOfAlcohol,
        dailyAmountOfCigaret: candidat.medecine_questions.dailyAmountOfCigaret,
        otherMedicalTroubles: candidat.medecine_questions.otherMedicalTroubles,
        isSportPractician: candidat.medecine_questions.isSportPractician,
        isSportPracticianComment: candidat.medecine_questions.isSportPracticianComment,
        yesComment: candidat.medecine_questions.yesComment,
        medicationList: candidat.medecine_questions.medicationList
      });
    } else {
      form.setFieldsValue({
        hasDisability: 0,
        hasDisabilityComment: "",
        hasInjury: 0,
        hasInjuryComment: "",
        eyeWards: 1,
        eyeWardsComment: "",
        orl: 1,
        orlComment: "",
        teethMouth: 1,
        teethMouthComment: "",
        lungChest: 1,
        lungChestComment: "",
        cardiovascular: 1,
        cardiovascularComment: 0,
        abs: 1,
        absComment: "",
        musculoskeletal: 1,
        musculoskeletalComment: "",
        skinVarice: 1,
        skinVariceComment: "",
        lymphNodes: 1,
        lymphNodesComment: "",
        hasDizziness: 0,
        hasEpilepsy: 0,
        hasFainting: 0,
        hasBloodyNose: 0,
        hasEardischarge: 0,
        hasEarProblem: 0,
        hasSinusTrouble: 0,
        hasSleepApnea: 0,
        hasHeadach: 0,
        hasEyeTrouble: 0,
        heartTrouble: 0,
        hasAcuteArticularRhumatism: 0,
        hasChestHurt: 0,
        hasHighBloodPressure: 0,
        hasPalpitations: 0,
        hasArthritis: 0,
        hasChestHandsNumbness: 0,
        hasFrequentColdThroatHurt: 0,
        hasSciaticaBackPain: 0,
        mentalTrouble: 0,
        hasAvc: 0,
        hasPneumoniaPleurisy: 0,
        hasHayAsthmaCold: 0,
        hasPhysicalInactivity: 0,
        hasMuchSputum: 0,
        hasBloodySputum: 0,
        hasWeightLoss: 0,
        hasChronicFieverFatigue: 0,
        hasNightySweat: 0,
        hasShortnessOfBreath: 0,
        hasLossAppetite: 0,
        hasBloodyVomit: 0,
        hasStomachDigestionIssue: 0,
        hasStomachUlcer: 0,
        hasBloodyStool: 0,
        hasJointPain: 0,
        hasKidneyBladderDesease: 0,
        hasEyeInjury: 0,
        hasChronicDiarrheaConstipation: 0,
        hasBackInjury: 0,
        hasAllergies: 0,
        dailyAmountOfCigaret: 0,
        hasFractures: 0,
        hasBlockedKnee: 0,
        hasFlatFoot: 0,
        hasMuscularPainSprain: 0,
        hasHernia: 0,
        hasNervousDisorder: 0,
        hasDermatitis: 0,
        hasJaundice: 0,
        hasDiabete: 0,
        hasWearingLenses: 0,
        hasAdviceSurgery: 0,
        hasVaricoseVein: 0,
        hasFootSwelling: 0,
        hasBloodyUrine: 0,
        hasMenstrualDisorders: 0,
        hasCurrentMedication: 0,
        dailyGlassOfAlcohol: 0,
        otherMedicalTroubles: 0,
        isSportPractician: 1,
        isSportPracticianComment: "",
        yesComment: "",
        medicationList: ""
      });
    }
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
            type: "error",
            message: errorMessage
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
            form: form,
            layout: "vertical",
            onFinish: onFinish,
            children: [/*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Row, {
              children: /*#__PURE__*/_jsx(Col, {
                lg: 12,
                md: 12,
                children: /*#__PURE__*/_jsx("div", {
                  className: "pad cool-radius",
                  style: {
                    background: '#FFDE08',
                    padding: '10px'
                  },
                  children: /*#__PURE__*/_jsxs("p", {
                    children: [/*#__PURE__*/_jsx("b", {
                      children: "Nom complet: "
                    }), candidat.name, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
                      children: "T\xE9l\xE9phone: "
                    }), candidat.mobile, /*#__PURE__*/_jsx("br", {})]
                  })
                })
              })
            }), /*#__PURE__*/_jsx("h5", {
              children: "PRISE DE PARAMETRES"
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Row, {
              style: {
                background: '#EEE',
                padding: '7px',
                borderRadius: "8px"
              },
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 2,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "weight",
                  label: "Poids",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input, {})
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 2,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "tallness",
                  label: "Taille",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input, {})
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 2,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "ta",
                  label: "Tension arterielle",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input, {})
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 2,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "fc",
                  label: "Freq. Cardiaque",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input, {})
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 2,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "fr",
                  label: "Freq. respiratoire",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input, {})
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 2,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "temperature",
                  label: "Temperature",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Input, {})
                })
              })]
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h5", {
              children: "EXAMEN PHYSIQUE"
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    background: '#EEE',
                    padding: '7px',
                    borderRadius: "8px",
                    marginBottom: "8px"
                  },
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "hasDisability",
                    label: "Le patient pr\xE9sente t-il un handicap moteur ?",
                    rules: [{
                      required: true,
                      message: 'Champs obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Radio.Group, {
                      optionType: "button",
                      buttonStyle: "solid",
                      options: [{
                        label: 'Oui',
                        value: 1
                      }, {
                        label: 'Non',
                        value: 0
                      }]
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "hasDisabilityComment",
                    label: "Description du handicap",
                    children: /*#__PURE__*/_jsx(TextArea, {
                      autoSize: true
                    })
                  })]
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    background: '#EEE',
                    padding: '7px',
                    borderRadius: "8px",
                    marginBottom: "8px"
                  },
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "hasInjury",
                    label: "Blessure pre-existant",
                    rules: [{
                      required: true,
                      message: 'Champs obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Radio.Group, {
                      optionType: "button",
                      buttonStyle: "solid",
                      options: [{
                        label: 'Oui',
                        value: 1
                      }, {
                        label: 'Non',
                        value: 0
                      }]
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "hasInjuryComment",
                    label: "Description de la blessure",
                    children: /*#__PURE__*/_jsx(TextArea, {
                      autoSize: true
                    })
                  })]
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    background: '#EEE',
                    padding: '7px',
                    borderRadius: "8px",
                    marginBottom: "8px"
                  },
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "eyeWards",
                    label: "Oeil et pupilles",
                    rules: [{
                      required: true,
                      message: 'Champs obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Radio.Group, {
                      optionType: "button",
                      buttonStyle: "solid",
                      options: [{
                        label: 'NORMAL',
                        value: 1
                      }, {
                        label: 'ANORMAL',
                        value: 0
                      }]
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "eyeWardsComment",
                    label: "Observation",
                    children: /*#__PURE__*/_jsx(TextArea, {
                      autoSize: true
                    })
                  })]
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    background: '#EEE',
                    padding: '7px',
                    borderRadius: "8px",
                    marginBottom: "8px"
                  },
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "orl",
                    label: "ORL",
                    rules: [{
                      required: true,
                      message: 'Champs obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Radio.Group, {
                      optionType: "button",
                      buttonStyle: "solid",
                      options: [{
                        label: 'NORMAL',
                        value: 1
                      }, {
                        label: 'ANORMAL',
                        value: 0
                      }]
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "orlComment",
                    label: "Observation",
                    children: /*#__PURE__*/_jsx(TextArea, {
                      autoSize: true
                    })
                  })]
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    background: '#EEE',
                    padding: '7px',
                    borderRadius: "8px",
                    marginBottom: "8px"
                  },
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "teethMouth",
                    label: "Dents et bouche",
                    rules: [{
                      required: true,
                      message: 'Champs obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Radio.Group, {
                      optionType: "button",
                      buttonStyle: "solid",
                      options: [{
                        label: 'NORMAL',
                        value: 1
                      }, {
                        label: 'ANORMAL',
                        value: 0
                      }]
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "teethMouth",
                    label: "Observation",
                    children: /*#__PURE__*/_jsx(TextArea, {
                      autoSize: true
                    })
                  })]
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    background: '#EEE',
                    padding: '7px',
                    borderRadius: "8px",
                    marginBottom: "8px"
                  },
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "lungChest",
                    label: "Poummons et poitrine",
                    rules: [{
                      required: true,
                      message: 'Champs obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Radio.Group, {
                      optionType: "button",
                      buttonStyle: "solid",
                      options: [{
                        label: 'NORMAL',
                        value: 1
                      }, {
                        label: 'ANORMAL',
                        value: 0
                      }]
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "lungChestComment",
                    label: "Observation",
                    children: /*#__PURE__*/_jsx(TextArea, {
                      autoSize: true
                    })
                  })]
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    background: '#EEE',
                    padding: '7px',
                    borderRadius: "8px",
                    marginBottom: "8px"
                  },
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "cardiovascular",
                    label: "Cardiovasculaire",
                    rules: [{
                      required: true,
                      message: 'Champs obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Radio.Group, {
                      optionType: "button",
                      buttonStyle: "solid",
                      options: [{
                        label: 'NORMAL',
                        value: 1
                      }, {
                        label: 'ANORMAL',
                        value: 0
                      }]
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "cardiovascularComment",
                    label: "Observation",
                    children: /*#__PURE__*/_jsx(TextArea, {
                      autoSize: true
                    })
                  })]
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    background: '#EEE',
                    padding: '7px',
                    borderRadius: "8px",
                    marginBottom: "8px"
                  },
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "abs",
                    label: "Abdominaux",
                    rules: [{
                      required: true,
                      message: 'Champs obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Radio.Group, {
                      optionType: "button",
                      buttonStyle: "solid",
                      options: [{
                        label: 'NORMAL',
                        value: 1
                      }, {
                        label: 'ANORMAL',
                        value: 0
                      }]
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "absComment",
                    label: "Observation",
                    children: /*#__PURE__*/_jsx(TextArea, {
                      autoSize: true
                    })
                  })]
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    background: '#EEE',
                    padding: '7px',
                    borderRadius: "8px",
                    marginBottom: "8px"
                  },
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "musculoskeletal",
                    label: "Musculo-squelettique",
                    rules: [{
                      required: true,
                      message: 'Champs obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Radio.Group, {
                      optionType: "button",
                      buttonStyle: "solid",
                      options: [{
                        label: 'NORMAL',
                        value: 1
                      }, {
                        label: 'ANORMAL',
                        value: 0
                      }]
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "musculoskeletalComment",
                    label: "Observation",
                    children: /*#__PURE__*/_jsx(TextArea, {
                      autoSize: true
                    })
                  })]
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    background: '#EEE',
                    padding: '7px',
                    borderRadius: "8px",
                    marginBottom: "8px"
                  },
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "skinVarice",
                    label: "Peau / Varices",
                    rules: [{
                      required: true,
                      message: 'Champs obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Radio.Group, {
                      optionType: "button",
                      buttonStyle: "solid",
                      options: [{
                        label: 'NORMAL',
                        value: 1
                      }, {
                        label: 'ANORMAL',
                        value: 0
                      }]
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "skinVariceComment",
                    label: "Observation",
                    children: /*#__PURE__*/_jsx(TextArea, {
                      autoSize: true
                    })
                  })]
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsxs("div", {
                  style: {
                    background: '#EEE',
                    padding: '7px',
                    borderRadius: "8px",
                    marginBottom: "8px"
                  },
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    name: "lymphNodes",
                    label: "Ganglions lymphatiques",
                    rules: [{
                      required: true,
                      message: 'Champs obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Radio.Group, {
                      optionType: "button",
                      buttonStyle: "solid",
                      options: [{
                        label: 'NORMAL',
                        value: 1
                      }, {
                        label: 'ANORMAL',
                        value: 0
                      }]
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    name: "lymphNodesComment",
                    label: "Observation",
                    children: /*#__PURE__*/_jsx(TextArea, {
                      autoSize: true
                    })
                  })]
                })
              })]
            }), /*#__PURE__*/_jsx("h5", {
              children: "ANTECEDANTS MEDICAUX"
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasDizziness",
                  label: "Vertiges",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasEpilepsy",
                  label: "Epilepsie",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasFainting",
                  label: "Evanouissement",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasBloodyNose",
                  label: "Saignement de nez frequent",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasEardischarge",
                  label: "Decharge des oreilles",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasEarProblem",
                  label: "Problemes d'audition",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasSinusTrouble",
                  label: "Troubles de sinus",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasSleepApnea",
                  label: "Apn\xE9e du sommeil",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasHeadach",
                  label: "Maux de tete frequents",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasEyeTrouble",
                  label: "Problemes de vision",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "heartTrouble",
                  label: "Problemes cardiaques",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasAcuteArticularRhumatism",
                  label: "Rhumatisme articulaire aigu",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasChestHurt",
                  label: "Douleurs \xE0 la poitrine",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasHighBloodPressure",
                  label: "Hypertension arterielle",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasPalpitations",
                  label: "Palpitations",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasArthritis",
                  label: "Arthrite",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasChestHandsNumbness",
                  label: "Engourdissements ou picotements de la poitrine / des bras",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasFrequentColdThroatHurt",
                  label: "Rhume / Maux de gorge frequents",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasSciaticaBackPain",
                  label: "Mal de dos, sciatique, lumbago",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "mentalTrouble",
                  label: "Probl\xE8me d'ordre mental ou psychiatrique Durant les 12 derniers mois",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasAvc",
                  label: "Accident vasculaire c\xE9r\xE9bral",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasPneumoniaPleurisy",
                  label: "Pneumonie, Pleur\xE9sie",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasHayAsthmaCold",
                  label: "Asthme/Rhume des foins",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasPhysicalInactivity",
                  label: "Inactivit\xE9 physique",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasMuchSputum",
                  label: "Production excessive de crachat",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasBloodySputum",
                  label: "Pr\xE9sence de sang dans le crachat",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasWeightLoss",
                  label: "Perte soudaine de poids",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasChronicFieverFatigue",
                  label: "Fi\xE8vre, fatigue chronique",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasNightySweat",
                  label: "Sueurs nocturnes",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasShortnessOfBreath",
                  label: "Essouflement",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasLossAppetite",
                  label: "Perte d'appetit",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasBloodyVomit",
                  label: "Pr\xE9sence de sang dans le vomis",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasStomachDigestionIssue",
                  label: "Indigestion, brulure d'estomac",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasStomachUlcer",
                  label: "Ulc\xE8re stomacal",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasBloodyStool",
                  label: "Pr\xE9sence de sang dans les selles",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasJointPain",
                  label: "Douleurs articulaires",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasKidneyBladderDesease",
                  label: "Maladie des reins ou de la vessie",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasEyeInjury",
                  label: "Blessures oculaires",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasChronicDiarrheaConstipation",
                  label: "Diarh\xE9e ou constipation chronique",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "dailyAmountOfCigaret",
                  label: "Nombre de cigarette(s) fum\xE9s par jour",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(InputNumber, {})
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasBackInjury",
                  label: "Blessure de dos",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasAllergies",
                  label: "Allergies",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasFractures",
                  label: "Fractures",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasBlockedKnee",
                  label: "Genou bloqu\xE9",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasFlatFoot",
                  label: "Pied plat",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasMuscularPainSprain",
                  label: "Douleurs musculaires ou entorses",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasHernia",
                  label: "Hernie (rupture)",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasNervousDisorder",
                  label: "Troubles nerveux",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasDermatitis",
                  label: "Dermatite (ou eruption cutan\xE9e)",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasJaundice",
                  label: "Jaunice",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasDiabete",
                  label: "Diab\xE8te",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasWearingLenses",
                  label: "Port de lentilles de contact",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasAdviceSurgery",
                  label: "Vous a-t-on d\xE9j\xE0 conseill\xE9 une chirurgie ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasVaricoseVein",
                  label: "Varices",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasFootSwelling",
                  label: "Gonflement des pieds ou chevilles",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasBloodyUrine",
                  label: "Sang dans les urines",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasMenstrualDisorders",
                  label: "Troubles menstruels (femmes uniquement)",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "hasCurrentMedication",
                  label: "M\xE9dication en cours",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "dailyGlassOfAlcohol",
                  label: "Nbre de verres d'alcool consomm\xE9 par jour",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(InputNumber, {})
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 3,
                sm: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "otherMedicalTroubles",
                  label: "Autre probl\xE8me medical non mentionn\xE9 dans ce formulaire",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                })
              })]
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsxs(Col, {
                lg: 6,
                md: 6,
                style: {
                  background: '#EEE',
                  padding: '7px',
                  borderRadius: "8px"
                },
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "isSportPractician",
                  label: "L'employ\xE9 pratique t-il une activit\xE9 physique r\xE9guli\xE8re ?",
                  rules: [{
                    required: true,
                    message: 'Champs obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: 'OUI',
                      value: 1
                    }, {
                      label: 'NON',
                      value: 0
                    }]
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "isSportPracticianComment",
                  label: "Si oui, le type et la frequence",
                  children: /*#__PURE__*/_jsx(TextArea, {
                    autoSize: true
                  })
                })]
              }), /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "yesComment",
                  label: "Si une reponse \xE0 ce questionnaire est oui, veuillez mentionner les details",
                  children: /*#__PURE__*/_jsx(TextArea, {
                    autoSize: true
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "omittedTroubles",
                  label: "Mentionner les probl\xE8mes m\xE9dicaux non mention\xE9s dans ce formulaire",
                  children: /*#__PURE__*/_jsx(TextArea, {
                    autoSize: true
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "medicationList",
                  label: "Liste des m\xE9dicaments pris",
                  children: /*#__PURE__*/_jsx(TextArea, {
                    autoSize: true
                  })
                })
              })]
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                loading: isFormProcessing,
                type: "primary",
                htmlType: "submit",
                children: /*#__PURE__*/_jsx("b", {
                  children: "SAUVEGARDER"
                })
              })
            })]
          })]
        })
      })
    })
  });
};

export default MedForm;